import { useEffect, useState } from 'react'

import { productosService, type ProductoGrupo } from '@/features/productos/services/productos.service'

export function useProductos(lang?: string) {
  const [productos, setProductos] = useState<ProductoGrupo[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    setLoading(true)
    setError(null)

    productosService
      .listar(lang)
      .then((data) => {
        if (!cancelled) setProductos(data)
      })
      .catch(() => {
        if (!cancelled) setError('No se pudo cargar el catálogo de productos.')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => { cancelled = true }
  }, [lang])

  return { productos, loading, error }
}
